<footer class="footer">
  <div class="container">
    <div class="footer-grid">
      
      <!-- Brand Column -->
      <div class="footer-brand">
        <img src="https://www.kotha.com.bd/assets/home/img/kothaLogo.png" alt="Kotha Logo" class="footer-logo">
        <p class="brand-desc">
          The next-generation IP Telephony service by BDCOM, providing enterprise-grade communication solutions across Bangladesh since 2024.
        </p>
        <div class="social-links">
          <a href="#" class="social-icon" aria-label="Facebook">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
          </a>
          <a href="#" class="social-icon" aria-label="Twitter">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>
          </a>
          <a href="#" class="social-icon" aria-label="LinkedIn">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
          </a>
        </div>
      </div>

      <!-- Links Column 1 -->
      <div class="footer-links">
        <h4 class="footer-heading">Solutions</h4>
        <ul>
          <li><a href="#">Enterprise PBX</a></li>
          <li><a href="#">SIP Trunking</a></li>
          <li><a href="#">Call Center</a></li>
          <li><a href="#">Hardware</a></li>
        </ul>
      </div>

      <!-- Links Column 2 -->
      <div class="footer-links">
        <h4 class="footer-heading">Company</h4>
        <ul>
          <li><a href="#">About BDCOM</a></li>
          <li><a href="#">Careers</a></li>
          <li><a href="#">Newsroom</a></li>
          <li><a href="#">Contact Us</a></li>
        </ul>
      </div>

      <!-- Support Column -->
      <div class="footer-links">
        <h4 class="footer-heading">Support</h4>
        <ul>
          <li><a href="#">Help Center</a></li>
          <li><a href="#">API Documentation</a></li>
          <li><a href="#">System Status</a></li>
        </ul>
        <div class="footer-contact-info mt-4">
          <p><strong>Hotline:</strong> 09666 666 666</p>
          <p><strong>Email:</strong> info&#64;kotha.com.bd</p>
        </div>
      </div>

    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <p>&copy; 2026 BDCOM Online Ltd. All rights reserved.</p>
      <div class="footer-legal">
        <a href="#">Privacy Policy</a>
        <a href="#">Terms of Service</a>
      </div>
    </div>
  </div>
</footer>
